module.exports = __webpack_public_path__ + "img/step-2.b411c826.jpg";